import { useQuery } from '@tanstack/react-query';

import { objectionResponsesTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getObjectionResponses: objectionResponsesTypes.GetObjectionResponses = ({ aiId }) => {
  return axios.get('/ai/objection-responses', { params: { aiId } });
};

type QueryFnType = typeof getObjectionResponses;

type UseGetObjectionResponsesOptions = {
  aiId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetObjectionResponses = ({
  aiId,
  config = {},
}: UseGetObjectionResponsesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['objection-responses', aiId],
    queryFn: () => getObjectionResponses({ aiId }),
  });
};
